import React, { useMemo } from 'react';

const TypingIndicator = () => {
  return useMemo(() => (
    <div className="message assistant typing-indicator">
      <div className="message-header">
        <span className="message-sender">🤖 SentencIA</span>
      </div>
      <div className="message-content">
        <div className="typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span className="typing-text">Analizando normativa...</span>
      </div>
    </div>
  ), []);
};

export default TypingIndicator;
